import { render, staticRenderFns } from "./TaxEditModal.vue?vue&type=template&id=2534c6b1&scoped=true&"
import script from "./TaxEditModal.vue?vue&type=script&lang=js&"
export * from "./TaxEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2534c6b1",
  null
  
)

export default component.exports